import { useTranslation } from 'react-i18next';

import { ImagePreviewDialog } from '@shared/ui';
import { useCertificationCardPreview } from '../api/use-certification-card-preview';

export function CertificationCardPreview({
  href,
  viewerAccessScope,
  onClose,
}: {
  href: string;
  viewerAccessScope: string;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  const query = useCertificationCardPreview(href, viewerAccessScope);
  const title = t('crm.customerLearning.actions.viewCertificate', {
    defaultValue: 'Open certification card',
  });
  return (
    <ImagePreviewDialog
      open
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      src={query.src}
      alt={title}
      title={title}
      closeLabel={t('common.close', { defaultValue: 'Close' })}
      pendingState={
        query.isError
          ? {
              status: 'error',
              label: t('crm.customerDocuments.preview.error', {
                defaultValue: 'Preview unavailable',
              }),
              retryLabel: t('common.retry', { defaultValue: 'Retry' }),
              onRetry: () => void query.refetch(),
            }
          : !query.src
            ? { status: 'loading', label: t('common.loading', { defaultValue: 'Loading' }) }
            : undefined
      }
    />
  );
}
